<template lang="pug">
  .profile-page.page
    .container
      .profile-page__container
        .profile-page__side
          side-nav(
            v-bind:sideNavData="sideNavData"
          )
        .profile-page__main
          .profile-page__header
            .profile-page__title
              h1.title Заявки
          .profile-page__body
            .requests
              .requests__header
                .tabs
                  .tabs__item(
                    v-for="(tab, index) in tabs"
                    :key="tab.name"
                  )
                    .button(
                      :class="{ 'button_paint-main': currentTab === index }"
                      @click="switchTab(index)"
                    ) {{tab.text}}

              .requests__body
                .requests__list
                  .requests-list
                    .requests-list__item(
                      v-if="ordersData.length === 0"
                    ) Нет заявок
                    .requests-list__item(
                      v-for="(request, $index) in ordersData"
                      :key="$index"
                    )
                      request-obj(
                        :request="request"
                        :ordersData="ordersData"
                        :on-remove-order="removeOrder"
                      )
    .page__footer
      main-footer
</template>
<script>
import {mapActions} from "vuex";

import SideNav from "@/components/sideNav/SideNav";
import MainFooter from "@/components/footer/Footer";
import RequestObj from "../components/RequestObj";

export default {
  name: "Requests",
  components: {
    RequestObj,
    SideNav,
    MainFooter
  },
  props: ["sideNavData"],
  data() {
    return {
      currentTab: 0,
      tabs: [
        {
          name: "activeRequests",
          text: "Активные заявки"
        },
        {
          name: "archiveRequests",
          text: "Архив заявок"
        }
      ],
      ordersData: []
    };
  },
  computed: {
    isArchive() {
      return Number(this.$route.query.is_archive);
    }
  },
  methods: {
    ...mapActions(["getOrders", "changeOrderStatus"]),
    switchTab: function(index) {
      this.$router.replace({name: "Requests", query: {is_archive: index}});
    },
    removeOrder(request) {
      this.ordersData = this.ordersData.filter(el => el.id !== request.id);
    },
    buildOrdersData() {
      this.currentTab = this.isArchive ? this.isArchive : 0;
      //todo взять статусы из каталога
      const statuses = this.isArchive ? "10,11,12" : "1,2,3,4,5,6,7,8,9";
      this.getOrders({
        // is_archive: this.currentTab
        statuses: statuses
      }).then(data => {
        this.ordersData = data;
      });
    }
  },
  mounted() {
    this.buildOrdersData();
  },
  watch: {
    "$route.query"() {
      this.buildOrdersData();
    }
  }
};
</script>
